var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17l-6-7h5V1h2v9h5l-6 7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15v6h20v-6h2v7a1 1 0 01-1 1H1a1 1 0 01-1-1v-7h2z"
  })));
}
export default SvgDownload;